// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HistoryItem_wrapper__2MkNU","product":"HistoryItem_product__2IYi_","image":"HistoryItem_image__1Rp7C","price":"HistoryItem_price__3KD5R"};